module.exports = __webpack_public_path__ + "static/img/glove_tilleul.4ad67e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_tilleul.png
// module id = vRJF
// module chunks = 0